import application from 'application/application';

import 'select2';

application.directive('ngCustomSelectLazyLoadInss', [
	'$timeout',
	'API',
	'environment',
	($timeout, API, environment) => ({
		restrict: 'A',
		scope: {},
		link(scope, element, attributes) {
			$.fn.select2.defaults.set('language', {
				inputTooLong: args => {
					let overChars = args.input.length - args.maximum;

					return `Apague ${overChars} caracter${overChars > 1 ? 'es' : ''}`;
				},
				inputTooShort: args => {
					let remainingChars = args.minimum - args.input.length;

					return `Digite ${remainingChars} ou mais caracteres`;
				},
				maximumSelected: args => {
					const maximumSelection = args.maximum;

					return `Você só pode selecionar ${maximumSelection} ite${
						maximumSelection > 1 ? 'ns' : 'm'
					}`;
				},
				searching: () => 'Buscando…',
				removeAllItems: () => 'Remover todos os itens',
				noResults: () => 'Nenhum resultado encontrado',
				loadingMore: () => 'Carregando mais…',
				errorLoading: () => 'Os resultados não puderam ser carregados.'
			});

			let getCustomUrl = API[attributes.paths].paths[attributes.customUrl];

			let url = `https://dev-api.advise.com.br/core/v1/${getCustomUrl}`;

			if (environment.name === 'homologation')
				url = `https://homologacao-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (API.default.hostname.includes('sandbox-'))
				url = `https://sandbox-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (environment.name === 'production')
				url = `https://api.advise.com.br/core/v1/${getCustomUrl}`;

			const headers = localStorage.getItem('__authenticationToken__')
				? {
						Authorization:
							'Bearer ' + localStorage.getItem('__authenticationToken__')
				  }
				: {};

			const customSearch = attributes.ngCustomRegex
				? eval(`(${attributes.ngCustomRegex})`)
				: false;

			$(element)
				.select2({
					width: '100%',
					placeholder: attributes.placeholder,
					minimumInputLength: attributes.minimumLengthToSearch,
					maximumInputLength: attributes.maximumLengthToSearch,
					dropdownParent:
						'ngSelectRelativeElement' in attributes
							? $(element).closest(
									attributes.ngSelectRelativeElement
										? attributes.ngSelectRelativeElement
										: 'body'
							  )
							: $(element).closest('.modal').length
							? $(element).closest('form')
							: '',
					containerCssClass: attributes.customSelectClass,
					dropdownCssClass: attributes.customDropClass,
					ajax: {
						delay: 250,
						url: url,
						headers: headers,
						data(params) {
							const groupData = JSON.parse(
								localStorage.getItem('__groupUserData__')
							);
							const groupUserSelected = JSON.parse(
								localStorage.getItem('__groupSelected__')
							);
							let object = {
								paginaAtual: params.page || 1,
								registrosPorPagina: 10,
								idGrupoUsuarios:
									groupUserSelected && groupData ? groupData.idGrupo : null
							};

							if (params['term']) {
								object[attributes.ngSelectParam] = customSearch
									? customSearch(params.term)
									: params.term;
							}

							return object;
						},
						processResults(data) {
							if (attributes.ngSelectParam == 'dadoAcesso') {
								if (data.itens) {
									const uniqueItems = [];
									const dadoAcessoCadastrados = [];

									data.itens.forEach(item => {
										if (!uniqueItems.includes(item.dadoAcesso)) {
											uniqueItems.push(item.dadoAcesso);
											dadoAcessoCadastrados.push(item);
										}
									});

									scope.resultsData = dadoAcessoCadastrados;

									return {
										results: scope.resultsData.map(item => {
											const results = {
												id: attributes.ngCustomValue
													? item[attributes.ngCustomValue]
													: item.idPesqAcessoFonteUsCliente,
												text: attributes.ngCustomLabel
													? item[attributes.ngCustomLabel]
													: item.dadoAcesso,
												value: attributes.ngCustomValue
													? item[attributes.ngCustomValue]
													: item.idPesqAcessoFonteUsCliente
											};

											if (item.idFonteXTipoPesquisa)
												results.idFonteXTipoPesquisa =
													item.idFonteXTipoPesquisa;
											if (item.idInstituicao)
												results.idInstituicao = item.idInstituicao;

											scope.results = results;

											return results;
										}),
										pagination: {
											more: data.itens.length === 10 ? true : false
										}
									};
								}
							}
							if (attributes.ngSelectParam == 'numeroProcesso') {
								if (data.itens) {
									const uniqueItems = [];
									const numeroProcessoCadastrados = [];

									data.itens.forEach(item => {
										if (!uniqueItems.includes(item.numeroProcesso)) {
											uniqueItems.push(item.numeroProcesso);
											numeroProcessoCadastrados.push(item);
										}
									});

									scope.resultsData = numeroProcessoCadastrados;

									return {
										results: scope.resultsData.map(item => {
											const results = {
												id: attributes.ngCustomValue
													? item[attributes.ngCustomValue]
													: item.idPesqAcessoFonteUsCliente,
												text: attributes.ngCustomLabel
													? item[attributes.ngCustomLabel]
													: item.dadoAcesso,
												value: attributes.ngCustomValue
													? item[attributes.ngCustomValue]
													: item.idPesqAcessoFonteUsCliente
											};

											if (item.numeroProcesso)
												results.numeroProcesso = item.numeroProcesso;

											scope.results = results;

											return results;
										}),
										pagination: {
											more: data.itens.length === 10 ? true : false
										}
									};
								}
							}
						}
					},
					templateResult: item => {
						return attributes.customElementClass !== undefined
							? customizeElement(item, attributes.customElementClass)
							: item.text;
					},
					templateSelection: item => {
						return attributes.customElementClass !== undefined
							? customizeElement(item, attributes.customElementClass)
							: item.text;
					},
					theme: attributes.customSelectTheme
				})

				.on('select2:open', () => {
					// $('.select2-dropdown').css({
					// 	'min-width': '100px'
					// });

					$('.select2-results__options').on('mousedown', e => {
						if (e.button == 1) return false;
					});

					setTimeout(() => {
						const searchField = document.querySelector(
							'.select2-container .select2-search__field'
						);

						if (searchField) {
							searchField.focus();
							searchField.click();

							// const maxLength =
							// 	attributes.ngSelectParam === 'dadoAcesso'
							// 		? 20
							// 		: attributes.ngSelectParam === 'numeroProcesso'
							// 		? 150
							// 		: null;

							// function limitInputLength() {
							// 	if (searchField.value.length > maxLength) {
							// 		searchField.value = searchField.value.slice(0, maxLength);
							// 	}
							// }

							// if (maxLength) {
							// 	searchField.removeEventListener('input', limitInputLength);

							// 	searchField.addEventListener('input', limitInputLength);
							// }
						}
					}, 100);
				})

				.on('select2:select', event =>
					$timeout(() => {
						if (scope.results.idFonteXTipoPesquisa) {
							scope.resultsData.map(item => {
								$(element).attr('ng-custom-model', item.dadoAcesso);
								$(element).attr('ng-process-value', item.dadoAcesso);
							});
						} else if (scope.results.numeroProcesso) {
							scope.resultsData.map(item => {
								$(element).attr('ng-custom-model', item.numeroProcesso);
								$(element).attr('ng-process-value', item.idProcesso);
							});
						} else {
							$(element).attr(
								'ng-custom-model',
								$(event.currentTarget)
									.find('option:selected')
									.val()
							);
						}

						scope.$apply();
					})
				)

				.on('select2:opening', () =>
					$(window).on('resize.select2', () => $(element).select2('close'))
				)

				// Desatch resize event on close
				.on('select2:closing', () => $(window).off('resize.select2'));

			// Remover o title inicial.
			removeSelectionTitle(element);

			// Remover o title após alterações da seleção.
			$(element).on('change.removeSelectionTitle', () => {
				removeSelectionTitle(element);
			});
		}
	})
]);

function customizeElement(el, elClass) {
	if ((el.element && el.element.classList[0]) != undefined) {
		let where = el.element.classList[0].slice(5);
		let span = document.createElement('span');
		let text = document.createTextNode(el.text);

		if (el.text.indexOf(where) > -1) span.classList.add(elClass);

		span.appendChild(text);

		return span;
	} else {
		return el.text;
	}
}

function removeSelectionTitle(element) {
	const select2 = $(element).data('select2');

	if (!select2) return;

	select2.$container.find('.select2-selection__rendered').removeAttr('title');
}
